import React from 'react';
import { Flex, Grid, Icon, Text } from 'core/components';

/**
 * Two-column key/value grid used by PeeringDB detail views. Shared between the
 * ASN detail drawer (`PeeringInfo`) and the AIA PeeringDB tool result so they
 * stay visually consistent.
 */
export function DataGrid({ children, ...rest }) {
  return (
    <Grid gridTemplateColumns="minmax(33%, auto) 1fr" gridRowGap="4px" {...rest}>
      {children}
    </Grid>
  );
}

export function DataRow({ label, value, display, fallback = 'None', title = value }) {
  return (
    <>
      <Text small muted>
        {label}
      </Text>
      <Text small ellipsis muted={!value} title={title}>
        {value ? display || value : fallback}
      </Text>
    </>
  );
}

export function ExternalLink({ to }) {
  if (!to) {
    return null;
  }

  return (
    <a href={to} target="_blank" rel="noreferrer">
      {to}
    </a>
  );
}

export function PolicyLocations({ value }) {
  const iconMap = {
    Preferred: <Icon color="success" icon="success" iconSize={12} />,
    'Required - US': <Icon color="warning" icon="warning-sign" iconSize={12} />,
    'Required - EU': <Icon color="warning" icon="warning-sign" iconSize={12} />,
    'Required - International': <Icon color="danger" icon="error" iconSize={12} />
  };

  return (
    <Flex gap="6px">
      {iconMap[value] || null}
      <div>{value}</div>
    </Flex>
  );
}
